// Flip this one value to switch environments: 'qa' | 'dev' | 'prod' | 'test'
const ACTIVE_ENV = 'dev';

const QA_BASE_URL = 'https://qaenv-bnh3qyskom.extremeb2b.com';
const DEV_BASE_URL = 'https://devenv-mturmyvlly.extremeb2b.com';
const PROD_BASE_URL = 'https://impaqx.extremeb2b.com';

const buildEnv = (baseUrl) => ({
	API_ENDPOINT_URL: baseUrl,
	API_ENDPOINT_DEVELOPERAPP_URL: baseUrl,
	API_ENDPOINT_PIKCLIX_URL: baseUrl,
	API_ENDPOINT_UI_URL: baseUrl,
	CONNECTOR_BASE_URL: baseUrl,
	API_ENDPOINT_DATA_MIGRATION: baseUrl,
	API_ENDPOINT_BLOG_STORAGE_URL: baseUrl,
	API_ENDPOINT_DATA_EXPORT: baseUrl,
	API_LOGTRACE_URL: baseUrl,
});

const environments = {
	qa: buildEnv(QA_BASE_URL),
	dev: buildEnv(DEV_BASE_URL),
	prod: buildEnv(PROD_BASE_URL),
	test: {
		API_ENDPOINT_URL: 'http://localhost:8080',
		API_ENDPOINT_DEVELOPERAPP_URL: 'http://localhost:8083',
		API_ENDPOINT_PIKCLIX_URL: 'http://localhost:8081',
		API_ENDPOINT_UI_URL: 'http://localhost:3000',
		CONNECTOR_BASE_URL: 'http://localhost:8782',
		API_ENDPOINT_DATA_MIGRATION: 'http://localhost:8784',
		API_ENDPOINT_BLOG_STORAGE_URL: 'http://localhost:8085',
		API_ENDPOINT_DATA_EXPORT: 'http://localhost:8090',
		API_LOGTRACE_URL: 'http://localhost:8785',
	},
};

export const env = environments[ACTIVE_ENV] || environments.qa;
